import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./LoginPage.css"; // Using the same styling for consistency
import APP_VERSION from "../version";

export default function GearPage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedGear, setSelectedGear] = useState([]);
  const [firstVisit, setFirstVisit] = useState(true);

  useEffect(() => {
    // Set firstVisit to false after the initial render
    setFirstVisit(false);
  }, []);
  useEffect(() => {
    const fetchSavedGear = async () => {
      try {
        const response = await fetch("/api/gear", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          }
        });
        if (!response.ok) throw new Error("Failed to load gear");
  
        const data = await response.json();
        setSelectedGear(data); // Expecting array of { name, shared }
      } catch (err) {
        console.error("❌ Could not load saved gear:", err);
      }
    };
  
    fetchSavedGear();
  }, []);
  
  const handleSearchChange = async (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query.length > 0) {
      try {
        const response = await fetch(`/api/gear/lookup?query=${query}`, { // Call backend API
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch gear lookup:", errorData.error || "Unknown error");
          setSearchResults([]);
          return;
        }
        const data = await response.json();
        setSearchResults(data); // Update with results from the backend
      } catch (error) {
        console.error("Error fetching gear lookup:", error);
        setSearchResults([]);
      }
    } else {
      setSearchResults([]); // Clear results if the query is empty
    }
  };

  const handleSelectGear = async (gearItem) => {
    if (!selectedGear.some(item => item.name === gearItem.name)) {
      const updatedGear = [...selectedGear, gearItem];
      setSelectedGear(updatedGear);
      setSearchQuery("");
      setSearchResults([]);
  
      try {
        const response = await fetch("/api/gear", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ selectedGear: [gearItem] }),
        });
  
        const data = await response.json();
        if (!response.ok) {
          console.error("❌ Auto-save gear failed:", data.error || "Unknown error");
        } else {
          console.log("✅ Gear auto-saved:", gearItem.name);
        }
      } catch (error) {
        console.error("❌ Error during auto-save:", error);
      }
    }
  };
  
  const handleRemoveGear = async (gearName) => {
    const updatedGear = selectedGear.filter((item) => item.name !== gearName);
    setSelectedGear(updatedGear);
  
    try {
      const response = await fetch("/api/gear/remove", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ gearName }), // ✅ fixed key
      });
  
      const data = await response.json();
      if (!response.ok) {
        console.error("❌ Failed to remove gear:", data.error || "Unknown error");
      } else {
        console.log("✅ Gear removed:", gearName);
      }
    } catch (error) {
      console.error("❌ Error during gear removal:", error);
    }
  };
  
  


   return (
    <div className="login-container">
      <div className="login-box">
        <img
          src="/gear-image.png"
          alt="Gear"
          style={{ width: "120px", margin: "0 auto 20px auto", display: "block" }}
        />
        <h2>Gear</h2>
        
          <p style={{ marginBottom: "15px", fontSize: "14px", color: "#555" }}>
            Gear you choose to "share" will be visible to other users in group trips
          </p>
          
        <div className="login-form" style={{ marginBottom: "20px", position: "relative" }}>
          <input
            type="text"
            placeholder="Search for and add your gear"
            value={searchQuery}
            onChange={handleSearchChange}
            style={{
              width: "100%",
              border: "1px solid #ccc",
              padding: "10px",
              borderRadius: "6px",
            }}
          />
          {searchResults.length > 0 && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderTop: "none",
                borderRadius: "0 0 6px 6px",
                zIndex: 1000,
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              {searchResults.map((result) => (
                <div
                key={result.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start", // ✅ keep name left-aligned
                  padding: "10px",
                  borderBottom: "1px solid #eee",
                  color: "#000",
                  backgroundColor: "#fff",
                  gap: "10px"
                }}
              >
                <span style={{ flexGrow: 1, textAlign: "left" }}>{result.name}</span> {/* ✅ name left-aligned */}
              
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <label style={{ display: "flex", alignItems: "center", fontSize: "0.9em", gap: "4px" }}>
                    <input
                      type="checkbox"
                      checked={!!result.shared}
                      onChange={(e) => {
                        const updated = searchResults.map(item =>
                          item.id === result.id ? { ...item, shared: e.target.checked } : item
                        );
                        setSearchResults(updated);
                      }}
                    />
                    Share
                  </label>
              
                  <button
                    onClick={() => {
                      handleSelectGear({
                        name: result.name,
                        shared: !!result.shared,
                      });
                    }}
                    style={{
                      backgroundColor: "#2c7373",
                      color: "#fff",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "0.8em",
                      fontWeight: "bold"
                    }}
                  >
                    Select
                  </button>
                </div>
              </div>
              
                         ))}
                        </div>
                      )}
                </div>
  
        {/* ✅ Gear Grid */}
        <div
            style={{
                backgroundColor: "#fff",
                padding: "10px",
                marginTop: "20px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                minHeight: "100px",
                display: "flex",
                flexWrap: "wrap",
                gap: "6px 10px", // 6px vertical, 10px horizontal
                alignItems: "flex-start",
            }}
            >
          {selectedGear.length === 0 ? (
            <p style={{ color: "#777", fontStyle: "italic" }}>
              No gear selected yet
            </p>
          ) : (
            selectedGear.map((gear) => (
                <div
                    key={gear.name}
                    style={{
                        backgroundColor: "#f2f2f2",
                        padding: "6px 12px",
                        borderRadius: "16px",
                        fontSize: "0.9em",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        color: "#000",
                        lineHeight: "1",
                        whiteSpace: "nowrap",
                        alignSelf: "flex-start",
                        height: "32px", // ✅ Add this line
                    }}
                    >

               <span style={{ marginRight: "6px" }}>{gear.name}</span>
                {gear.shared && (
                <span style={{ fontSize: "0.75em", color: "#2c7373", marginRight: "4px" }}>
                    ✔ Shared
                </span>
                )}
                <button
                onClick={() => handleRemoveGear(gear.name)}
                aria-label={`Remove ${gear.name}`}
                style={{
                    background: "#ccc",
                    border: "none",
                    borderRadius: "50%",
                    color: "#333",
                    width: "18px",
                    height: "18px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                    transition: "background 0.2s, color 0.2s",
                }}
                onMouseOver={(e) => {
                    e.target.style.background = "#f44336";
                    e.target.style.color = "#fff";
                }}
                onMouseOut={(e) => {
                    e.target.style.background = "#ccc";
                    e.target.style.color = "#333";
                }}
                >
                ×
                </button>

              </div>
            ))
          )}
        </div>
          {/* ✅ Navigation & footer */}
        <button
          className="home-button"
          onClick={() => navigate("/")}
          style={{ marginTop: "30px", width: "100%" }}
        >
          Home
        </button>
        <div
          className="version-text"
          style={{
            marginTop: "20px",
            fontSize: "12px",
            color: "#ccc",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>
            Version: <strong>{APP_VERSION}</strong>
          </span>
          <span>
            <Link to="/logout" className="contact-link" style={{ marginRight: "16px" }}>
              Logout
            </Link>
            <Link to="/contact" className="contact-link">Contact us</Link>
          </span>
        </div>
      </div>
    </div>
  );
}